/**
 * DELETE RISK
 */

import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import siteStore from "@/entities/site/model/site.store"
import physicalRiskStore from "../../model/physical-risk.store"
import ModalConfirm from "@/components/modal-confirm"
import preventionActionStore from "@/entities/prevention-action/model/prevention-action.store"
import populationStore from "@/entities/population/model/population.store"
import { useState } from "react"
import Modal from "@/components/modal"
import LaunchButton from "@/components/LaunchButton"
import { faBuilding, faLocationDot, faRoute, faUserFriends } from "@fortawesome/free-solid-svg-icons"

interface Props {
  onClose: () => void
  onDelete: () => void
}

export default function PhysicalRiskDeleteModal(props: Props) {
  const dispatch = useAppDispatch()

  //Selector current risk
  const risk = useAppSelector(physicalRiskStore.selectors.draft)
  const isShared = useAppSelector(physicalRiskStore.selectors.isShared)
  const preventionActions = useAppSelector((state) => state.preventionAction.list)
  const status = useAppSelector(physicalRiskStore.selectors.status)
  const sitesForRisk = useAppSelector(siteStore.selectors.listForRisk)
  const populationsForRisk = useAppSelector(populationStore.selectors.listForRisk)

  //Modal to display
  const [modal, setModal] = useState<"DELETE_CHOOSE" | null>(initModal())

  //Mode
  function initModal() {
    if (isShared) {
      return "DELETE_CHOOSE"
    } else {
      return null
    }
  }

  async function handleRemovePopulation(populationId: string) {
    const response = await dispatch(
      physicalRiskStore.thunks.removePopulation({ PopulationId: populationId, PhysicalRiskId: risk.id })
    ).unwrap()
    if (response) {
      props.onClose()
    }
  }

  async function handleRemoveSite(siteId: string) {
    const response = await dispatch(
      physicalRiskStore.thunks.removeSite({ SiteId: siteId, PhysicalRiskId: risk.id })
    ).unwrap()
    if (response) {
      props.onClose()
    }
  }

  //Supprimer le risque
  async function handleDelete() {
    const response = await dispatch(physicalRiskStore.thunks.removeEntity(risk.id)).unwrap()
    if (response) {
      dispatch(preventionActionStore.actions.removeMany(
        preventionActions.filter((action) => action.PhysicalRiskId === risk.id).map((action) => action.id)
      ))
      props.onDelete()
      props.onClose()
    }
  }

  if (modal === "DELETE_CHOOSE") {
    return (
      <Modal title="Supprimer le risque" onClose={props.onClose} isCloseButtonVisible isLarge>
        <p className="mb-20">Pour quelle unité souhaitez-vous supprimer le risque « {risk.cName} » ?</p>
        <div className="grid grid-cols-2 gap-20">
          <LaunchButton
            preTitle="Supprimer pour"
            title="Tout l'établissement"
            icon={faBuilding}
            isCta
            ctaColor="#dc2626"
            onClick={() => setModal(null)}
          />
          {sitesForRisk.map((site) => (
            <LaunchButton
              key={site.id}
              preTitle="Supprimer pour le lieu"
              title={site.name}
              icon={site.geometryType === "line" ? faRoute : faLocationDot}
              iconColor="#dc2626"
              onClick={() => handleRemoveSite(site.id)}
            />
          ))}
          {populationsForRisk.map((population) => (
            <LaunchButton
              key={population.id}
              preTitle="Supprimer pour la fonction"
              title={population.name}
              icon={faUserFriends}
              iconColor="#dc2626"
              onClick={() => handleRemovePopulation(population.id)}
            />
          ))}
        </div>
      </Modal>
    )
  } else {
    return (
      <ModalConfirm
        status={status}
        onNo={() => props.onClose()}
        onYes={handleDelete}
        text={`Vous êtes sur le point de supprimer le risque « ${risk.cName} ». Cela supprimera aussi les mesures de prévention associées.`}
        textBold="Souhaitez-vous continuer ?"
      />
    )
  }
}
